import { Suspense, lazy } from 'react';
import { Route, useParams } from 'react-router-dom';
import PRIVILEGES from '../constants/privileges';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { RBACRoute } from './RBACRoute';

const Employees = lazy(() => import('../modules/admin/employees'));

const EmployeesTable = lazy(
  () => import('../modules/admin/employees/pages/EmployeesTable')
);
const EmployeeDetails = lazy(
  () => import('../modules/admin/employees/pages/EmployeeDetails')
);

const EmployeeDetailsWithRBAC = () => {
  const { eId } = useParams();
  const privilege =
    eId === 'new'
      ? PRIVILEGES.COMMON.EMPLOYEES_CREATE
      : PRIVILEGES.COMMON.EMPLOYEES_UPDATE;

  return (
    <RBACRoute privileges={[privilege]}>
      <Suspense fallback={<SkeletonPage />}>
        <EmployeeDetails />
      </Suspense>
    </RBACRoute>
  );
};

const EmployeeRoutes = (
  <>
    {' '}
    <Route
      path="employees"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <Employees />
        </Suspense>
      }
    >
      <Route
        path=":eId/:action/:details?"
        element={<EmployeeDetailsWithRBAC />}
      />
      <Route
        path=""
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.EMPLOYEES_VIEW]}>
            <Suspense fallback={<SkeletonPage />}>
              <EmployeesTable />
            </Suspense>
          </RBACRoute>
        }
      />
    </Route>
  </>
);

export default EmployeeRoutes;
